import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Injectable, inject, DestroyRef } from '@angular/core';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LiveNursesService } from 'src/app/recruiting/candidates/live-nurses-new/live-nurses.service';
import * as actions from 'src/app/recruiting/candidates/live-nurses-new/store/live-nurses.actions';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { LDFeatureManager } from 'src/app/shared/services/ld-feature-manager';
import { JobMatchingService } from 'src/app/shared/services/job-matching.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';

@Injectable()
export class JobPercentagesEffect {
    private readonly destroyRef = inject(DestroyRef);

    getJobPercentages$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadJobPercentages),
            switchMap((action) => {
                return this.ldFeatureManager.isEnabled(FeatureFlag.EnableJobMatchingRefactor).pipe(
                    switchMap((isEnabled) => {
                        const calculations$ = isEnabled
                            ? this.jobMatchingService.getRecruiterCalculations(action.recruiterId)
                            : this.liveNursesService.getRecruiterCalculations(action.recruiterId);

                        return calculations$.pipe(
                            map((response) =>
                                actions.loadJobPercentagesSuccess({
                                    percentages: response
                                })
                            ),
                            catchError((error: unknown) => of(actions.loadJobPercentagesFail({ error }))),
                            takeUntilDestroyed(this.destroyRef)
                        );
                    })
                );
            })
        );
    });

    getJobPercentagesFail$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(actions.loadJobPercentagesFail),
                tap((action) => {
                    console.log(action.error);
                    this.toaster.toast('Sorry. A problem occurred while loading Job Percentages.');
                })
            ),
        { dispatch: false }
    );

    constructor(
        private readonly actions$: Actions,
        protected liveNursesService: LiveNursesService,
        private readonly toaster: ToasterService,
        private readonly ldFeatureManager: LDFeatureManager,
        private readonly jobMatchingService: JobMatchingService
    ) {}
}
